/* eslint-disable no-underscore-dangle */

const env = window._env_.DEPLOYMENT_PROFILE;

const TRACKING_ID =
  env === 'dev' || env === 'preDev' ? process.env.REACT_APP_DevGAnalytic : process.env.REACT_APP_ProdGAnalytic;

// /inspection is a deep-linked mobile webview; skip GA4 to keep first paint lean.
const isInspection = window.location.pathname.startsWith('/inspection');

// Lazy-load react-ga4 (~12 KB raw) into its own chunk so the SDK never lands
// in main.js. On admin routes the chunk is requested as soon as the analytics
// module is first imported (same effective timing as the previous static
// import + module-load initialize, just off the critical path).
let gaPromise = null;
function loadGA() {
  if (isInspection) return Promise.resolve(null);
  if (gaPromise) return gaPromise;
  gaPromise = import(/* webpackChunkName: "react-ga4" */ 'react-ga4').then(({ default: ReactGA }) => {
    ReactGA.initialize(TRACKING_ID);
    return ReactGA;
  });
  return gaPromise;
}

if (!isInspection) {
  loadGA();
}

export const setUserId = (userId) => {
  if (isInspection) return;
  loadGA().then((ReactGA) => {
    if (!ReactGA) return;
    ReactGA.set({ user_id: userId });
    ReactGA.set({ userId });
  });
};

export const logPageView = (userId, duration) => {
  if (isInspection) return;
  loadGA().then((ReactGA) => {
    if (!ReactGA) return;
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title: window.location.pathname + window.location.search,
    });

    ReactGA.event({
      category: 'User',
      action: 'time_on_page',
      title: window.location.pathname + window.location.search,
      label: userId,
      value: Math.round(duration / 60000),
    });
  });
};
